import React, { PureComponent, Fragment } from 'react';
import { SelectOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Tooltip, Modal, Row, Col, Button, message, Radio } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import styles from '../style.less';
import { nl2br } from '../../../utils/utils';

class CreatePolicy extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      loading: false,
      visible: false,
    };
  }

  onChange = e => {
    this.setState({
      value: e.target.value,
    });
  };
  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = () => {
    message.success('Copied');
  };

  handleCancel = () => {
    this.setState({ visible: false });
  };

  render() {
    const Policy = `{
            "Version": "2012-10-17",
            "Statement": [
                {
                    "Effect": "Allow",
                    "Resource": "*",
                    "Action": [
                        "acm:Describe*",
                        "acm:List*",
                        "application-autoscaling:Describe*",
                        "appmesh:Describe*",
                        "appmesh:List*",
                        "appsync:List*",
                        "athena:List*",
                        "autoscaling:Describe*",
                        "batch:DescribeComputeEnvironments",
                        "batch:DescribeJobDefinitions",
                        "chime:List*",
                        "cloud9:Describe*",
                        "cloud9:ListEnvironments",
                        "clouddirectory:ListDirectories",
                        "cloudformation:DescribeStack*",
                        "cloudformation:GetTemplate",
                        "cloudformation:ListStack*",
                        "cloudformation:GetStackPolicy",
                        "cloudfront:Get*",
                        "cloudfront:List*",
                        "cloudhsm:ListHapgs",
                        "cloudhsm:ListHsms",
                        "cloudhsm:ListLunaClients",
                        "cloudsearch:DescribeDomains",
                        "cloudsearch:DescribeServiceAccessPolicies",
                        "cloudtrail:DescribeTrails",
                        "cloudtrail:GetEventSelectors",
                        "cloudtrail:GetTrailStatus",
                        "cloudtrail:ListTags",
                        "cloudtrail:LookupEvents",
                        "cloudwatch:Describe*",
                        "codebuild:ListProjects",
                        "codecommit:BatchGetRepositories",
                        "codecommit:GetBranch",
                        "codecommit:GetObjectIdentifier",
                        "codecommit:GetRepository",
                        "codecommit:List*",
                        "codedeploy:Batch*",
                        "codedeploy:Get*",
                        "codedeploy:List*",
                        "codepipeline:ListPipelines",
                        "codestar:Describe*",
                        "codestar:List*",
                        "cognito-identity:ListIdentityPools",
                        "cognito-idp:ListUserPools",
                        "cognito-sync:Describe*",
                        "cognito-sync:List*",
                        "comprehend:Describe*",
                        "comprehend:List*",
                        "config:Deliver*",
                        "config:Describe*",
                        "config:Get*",
                        "datapipeline:DescribeObjects",
                        "datapipeline:DescribePipelines",
                        "datapipeline:EvaluateExpression",
                        "datapipeline:GetPipelineDefinition",
                        "datapipeline:ListPipelines",
                        "datapipeline:QueryObjects",
                        "datapipeline:ValidatePipelineDefinition",
                        "datasync:Describe*",
                        "datasync:List*",
                        "dax:Describe*",
                        "dax:ListTags",
                        "directconnect:Describe*",
                        "dms:Describe*",
                        "dms:ListTagsForResource",
                        "ds:DescribeDirectories",
                        "dynamodb:DescribeContinuousBackups",
                        "dynamodb:DescribeGlobalTable",
                        "dynamodb:DescribeTable",
                        "dynamodb:DescribeTimeToLive",
                        "dynamodb:ListBackups",
                        "dynamodb:ListGlobalTables",
                        "dynamodb:ListStreams",
                        "dynamodb:ListTables",
                        "ec2:Describe*",
                        "ecr:DescribeRepositories",
                        "ecr:GetRepositoryPolicy",
                        "ecs:Describe*",
                        "ecs:List*",
                        "eks:DescribeCluster",
                        "eks:ListClusters",
                        "elasticache:Describe*",
                        "elasticbeanstalk:Describe*",
                        "elasticfilesystem:DescribeFileSystems",
                        "elasticloadbalancing:Describe*",
                        "elasticmapreduce:Describe*",
                        "elasticmapreduce:ListClusters",
                        "elasticmapreduce:ListInstances",
                        "es:Describe*",
                        "es:ListDomainNames",
                        "events:DescribeEventBus",
                        "events:ListRules",
                        "firehose:Describe*",
                        "firehose:List*",
                        "fsx:Describe*",
                        "fsx:List*",
                        "gamelift:ListBuilds",
                        "gamelift:ListFleets",
                        "glacier:DescribeVault",
                        "glacier:GetVaultAccessPolicy",
                        "glacier:ListVaults",
                        "globalaccelerator:Describe*",
                        "globalaccelerator:List*",
                        "greengrass:List*",
                        "guardduty:Get*",
                        "guardduty:List*",
                        "iam:GenerateCredentialReport",
                        "iam:Get*",
                        "iam:List*",
                        "iam:SimulateCustomPolicy",
                        "iam:SimulatePrincipalPolicy",
                        "iot:Describe*",
                        "iot:List*",
                        "kinesis:DescribeStream",
                        "kinesis:ListStreams",
                        "kinesis:ListTagsForStream",
                        "kinesisanalytics:ListApplications",
                        "kms:Describe*",
                        "kms:Get*",
                        "kms:List*",
                        "lambda:GetAccountSettings",
                        "lambda:GetPolicy",
                        "lambda:List*",
                        "license-manager:List*",
                        "logs:Describe*",
                        "logs:ListTagsLogGroup",
                        "machinelearning:DescribeMLModels",
                        "mediaconnect:Describe*",
                        "mediaconnect:List*",
                        "mediastore:GetContainerPolicy",
                        "mediastore:ListContainers",
                        "opsworks-cm:DescribeServers",
                        "organizations:List*",
                        "organizations:Describe*",
                        "quicksight:Describe*",
                        "quicksight:List*",
                        "ram:List*",
                        "rds:Describe*",
                        "rds:DownloadDBLogFilePortion",
                        "rds:ListTagsForResource",
                        "redshift:Describe*",
                        "rekognition:Describe*",
                        "rekognition:List*",
                        "robomaker:Describe*",
                        "robomaker:List*",
                        "route53:Get*",
                        "route53:List*",
                        "route53domains:GetDomainDetail",
                        "route53domains:GetOperationDetail",
                        "route53domains:ListDomains",
                        "route53domains:ListOperations",
                        "route53domains:ListTagsForDomain",
                        "route53resolver:List*",
                        "s3:GetAccelerateConfiguration",
                        "s3:GetAnalyticsConfiguration",
                        "s3:GetBucket*",
                        "s3:GetEncryptionConfiguration",
                        "s3:GetInventoryConfiguration",
                        "s3:GetLifecycleConfiguration",
                        "s3:GetMetricsConfiguration",
                        "s3:GetObjectAcl",
                        "s3:GetObjectVersionAcl",
                        "s3:GetPublicAccessBlock",
                        "s3:GetReplicationConfiguration",
                        "s3:ListAllMyBuckets",
                        "sagemaker:Describe*",
                        "sagemaker:List*",
                        "sdb:DomainMetadata",
                        "sdb:ListDomains",
                        "securityhub:Get*",
                        "securityhub:List*",
                        "serverlessrepo:GetApplicationPolicy",
                        "serverlessrepo:List*",
                        "ses:GetIdentityDkimAttributes",
                        "ses:GetIdentityVerificationAttributes",
                        "ses:ListIdentities",
                        "ses:ListVerifiedEmailAddresses",
                        "shield:Describe*",
                        "shield:List*",
                        "snowball:ListClusters",
                        "snowball:ListJobs",
                        "sns:GetTopicAttributes",
                        "sns:ListSubscriptionsByTopic",
                        "sns:ListTopics",
                        "sqs:GetQueueAttributes",
                        "sqs:ListQueues",
                        "ssm:Describe*",
                        "ssm:ListDocuments",
                        "states:ListStateMachines",
                        "storagegateway:DescribeBandwidthRateLimit",
                        "storagegateway:DescribeCache",
                        "storagegateway:DescribeCachediSCSIVolumes",
                        "storagegateway:DescribeGatewayInformation",
                        "storagegateway:DescribeMaintenanceStartTime",
                        "storagegateway:DescribeNFSFileShares",
                        "storagegateway:DescribeSnapshotSchedule",
                        "storagegateway:DescribeStorediSCSIVolumes",
                        "storagegateway:DescribeTapeArchives",
                        "storagegateway:DescribeTapeRecoveryPoints",
                        "storagegateway:DescribeTapes",
                        "storagegateway:DescribeUploadBuffer",
                        "storagegateway:DescribeVTLDevices",
                        "storagegateway:DescribeWorkingStorage",
                        "storagegateway:List*",
                        "tag:GetResources",
                        "tag:GetTagKeys",
                        "transfer:Describe*",
                        "transfer:List*",
                        "translate:List*",
                        "trustedadvisor:Describe*",
                        "waf:ListWebACLs",
                        "waf-regional:ListWebACLs",
                        "workspaces:Describe*"
                    ]
                },
                {
                    "Effect": "Allow",
                    "Action": [
                        "apigateway:HEAD",
                        "apigateway:GET",
                        "apigateway:OPTIONS"
                    ],
                    "Resource": [
                        "arn:aws:apigateway:*::/restapis",
                        "arn:aws:apigateway:*::/restapis/*/authorizers",
                        "arn:aws:apigateway:*::/restapis/*/authorizers/*",
                        "arn:aws:apigateway:*::/restapis/*/resources",
                        "arn:aws:apigateway:*::/restapis/*/resources/*",
                        "arn:aws:apigateway:*::/restapis/*/resources/*/methods/*",
                        "arn:aws:apigateway:*::/vpclinks"
                    ]
                }
            ]
        }`;
    const { visible, loading, value } = this.state;

    const { type } = this.props;
    return (
      <div>
        <Row>
          <Col span={20}>
            <Radio.Group onChange={this.onChange} value={this.state.value}>
              <Radio value={type}>
                {
                  <span>
                    <p style={{ fontWeight: 600, display: 'inline' }}>
                      Please Create this Policy on AWS
                    </p>
                    <p style={{ fontSize: '12px', marginLeft: '8%', marginBottom: '-17px' }}>
                      Copy the JSON data and paste it in your AWS Console
                      <br />
                    </p>
                  </span>
                }
              </Radio>
            </Radio.Group>
          </Col>
          <Col span={4} style={{ float: 'right' }}>
            <Button
              onClick={this.showModal}
              icon={<SelectOutlined />}
              style={{ maxHeight: '25px', fontSize: '10px' }}
              type="primary"
            >
              View Policy
            </Button>
            <Modal
              visible={visible}
              title="View Audit Policy"
              onOk={this.handleOk}
              onCancel={this.handleCancel}
              width="560px"
              bodyStyle={{ height: '300px', overflowY: 'scroll' }}
              footer={[
                <Button key="back" onClick={this.handleCancel}>
                  Cancel
                </Button>,
                <CopyToClipboard key="copy" text={Policy}>
                  {/* <Tooltip title="Copy Policy"> */}
                  <Button key="submit" type="primary" loading={loading} onClick={this.handleOk}>
                    Copy Policy
                  </Button>
                  {/* </Tooltip> */}
                </CopyToClipboard>,
              ]}
            >
              <pre style={{ overflow: 'initial' }}>
                <code dangerouslySetInnerHTML={{ __html: nl2br(Policy) }} />{' '}
              </pre>
            </Modal>
          </Col>
        </Row>
      </div>
    );
  }
}

export default CreatePolicy;
